import { useRouter } from "next/router";
import * as masterAccount from "@ecp-redux/api/masterAccount";
import { useOpenPortalSnackbar } from "../../shared/components/Snackbar/Snackbar";
import { IBoxButtonProps } from "./BoxButton.types";
import { isPortalSide } from "../../helpers/helpers";
import {
  EndpointActionType,
  ILinkContent,
  SelectedGoToOption,
} from "../../settingsPatterns/contentPatterns.types";
import { useBoxContext } from "../../structure/Contexts/BoxContext";

const useEndpointAction = (content: ILinkContent | undefined) => {
  const { messages } = useBoxContext<IBoxButtonProps>();
  const { openPortalSnackbar } = useOpenPortalSnackbar();
  const router = useRouter();

  const [trigger] = masterAccount.useLazyGetMasterAccountValidateTokenQuery();

  const isEndpointSelected =
    content &&
    content.selectedGoToOption === SelectedGoToOption.ENDPOINT_ACTION &&
    content.endpointActionSetting.endpointType !== EndpointActionType.NONE;

  const handleSnackbar = () => {
    if (
      !isEndpointSelected ||
      !content.endpointActionSetting ||
      !isPortalSide()
    )
      return;

    switch (content.endpointActionSetting.endpointType) {
      case EndpointActionType.RESEND_LINK: {
        const token = Array.isArray(router.query?.["token"])
          ? router.query?.["token"][0]
          : router.query?.["token"];

        const { snackbarSuccessStyle, snackbarErrorStyle } =
          content.endpointActionSetting;

        trigger(token ?? "")
          .unwrap()
          .then(() => {
            openPortalSnackbar(
              snackbarSuccessStyle,
              messages.resend_link_success_text
            );
          })
          .catch(() => {
            openPortalSnackbar(
              snackbarErrorStyle,
              messages.resend_link_error_text
            );
          });
        break;
      }
      case EndpointActionType.NONE: {
        break;
      }
      default: {
        break;
      }
    }
  };

  return { handleSnackbar };
};

export default useEndpointAction;
